/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';


import { INodeProps } from '@msdyn365-commerce-modules/utilities';

import { IHreflangModuleProps } from './hreflang-module.props.autogenerated';




const Hreflang: React.FC<IHreflangModuleProps<unknown> & INodeProps> = (props: INodeProps) => {
    const { context } = props;
    const country = context.request.sitePath && context.request.sitePath.split('/')[1]|| 'undefined';
    const baseURL = context.request.url.requestUrl.origin || "https://www.cittadesign.com";
    let path = context.request.url.requestUrl.pathname || '';
    if (country === 'au' || country === 'us') {
        path = path.replace(`/${country}`, '');
      }
    let hreflangs = [
        { lang: 'en-NZ', url: `${baseURL}${path}` },
        { lang: 'en-AU', url: `${baseURL}/au${path}` },
        { lang: 'en-US', url: `${baseURL}/us${path}` },
        { lang: 'x-default', url: `${baseURL}${path}` }
    ];
    return (
        <>
            {hreflangs.map(hreflang => (
                <link key={hreflang.lang} rel="alternate" hrefLang={hreflang.lang} href={hreflang.url} />
            ))}
        </>
    );
};

export default Hreflang;
